import { IRootState } from '../../../store'
import { IEmailDetails } from '../store/patientDemographics.types'

export const getEmailDetailsSelector = (state: IRootState): IEmailDetails => state.patientDemographics.emailDetails
